import React, { useEffect, useRef, useState } from "react";
import { BottomBar, ButtonGroup, CardsRenderer, CardsWrapper, Booking, DateRange, Pagination, Searchbox, Toast } from "../../../../../../../../Components";
import apis from "../../../../../../../../Utils/apis";
import { get } from "../../../../../../../../Utils/axios";
import moment from "moment";

function FlightBookings({ userId }) {
	const getDatesForStatus = (statusValue) => {
		if (statusValue === "upcoming") {
			return {
				startDate: moment().startOf("date").valueOf(),
				endDate: moment().add(30, "days").endOf("date").valueOf(),
			};
		}
		if (statusValue === "archived") {
			return {
				startDate: moment().subtract(30, "days").startOf("date").valueOf(),
				endDate: moment().subtract(1, "days").endOf("date").valueOf(),
			};
		}
		return getDatesForStatus("upcoming");
	};

	const [BookingStatus, setBookingStatus] = useState({ label: "Upcoming", value: "upcoming" });
	const initial = {
		bookings: [],
		count: 0,
		pages: 0,
	};
	const [Query, setQuery] = useState({
		search: "",
		page: 1,
		dates: getDatesForStatus("upcoming"),
	});
	const [Bookings, setBookings] = useState(initial);
	const [Loading, setLoading] = useState(true);
	const listTopRef = useRef(null);
	const currentItemsCount = Bookings.bookings?.length || 0;
	const totalPages = Math.max(1, Number(Bookings.pages) || 1);
	const currentPage = Math.min(Math.max(Query.page, 1), totalPages);
	const pageSize = currentItemsCount || 10;
	const pageStart = currentItemsCount ? (currentPage - 1) * pageSize + 1 : 0;
	const pageEnd = currentItemsCount ? pageStart + currentItemsCount - 1 : 0;

	useEffect(() => {
		fetchBookings(BookingStatus.value, Query);
	}, [BookingStatus, Query]);

	useEffect(() => {
		if (listTopRef.current) {
			listTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}, [Query.page]);

	const fetchBookings = (type, query) => {
		setLoading(true);
		let url;
		if (type === "upcoming") {
			url = apis.getBookedFlightBookings;
		} else if (type === "archived") {
			url = apis.getArchivedFlightBookings;
		}
		get(
			url,
			{
				...query,
				userId,
				dateField: "travelDate",
				dates: {
					startDate: moment(query.dates.startDate).toDate(),
					endDate: moment(query.dates.endDate).toDate(),
				},
			},
			(r, e) => {
				if (r) {
					setBookings(r);
					setLoading(false);
				} else if (e) {
					Toast.handleError(e);
					setLoading(false);
				}
			}
		);
	};

	return (
		<>
			<BottomBar>
				<div className="flex w-full flex-col gap-2">
					<div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
						<h5 className="leading-tight">{Bookings.count} Flight Bookings</h5>
						<div className="text-xs text-secondary whitespace-nowrap">
							Page {currentPage} of {totalPages}
						</div>
					</div>
					<div className="flex justify-start sm:justify-end">
						<Pagination showNumbers={false} active={currentPage} total={totalPages} onChange={(page) => setQuery({ ...Query, page })} />
					</div>
				</div>
			</BottomBar>
			<div ref={listTopRef} className="mt-4 flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
				<div className="w-full lg:w-auto">
					<ButtonGroup
						onClick={(status) => {
							setBookingStatus(status);
							setQuery((prev) => ({ ...prev, page: 1, dates: getDatesForStatus(status.value) }));
						}}
						size="xs !p-1.5"
						selected={BookingStatus}
						className="text-sm"
						options={[
							{ label: "Upcoming", value: "upcoming" },
							{ label: "Archived", value: "archived" },
						]}
					/>
				</div>
				<div className="flex w-full flex-col gap-2 md:flex-row md:items-center lg:w-auto lg:max-w-[min(100%,40rem)]">
					<Searchbox className="w-full md:flex-1 lg:min-w-[18rem]" placeholder="Search bookings" cmd="s" onChange={(search) => setQuery({ ...Query, search, page: 1 })} />
					<DateRange
						className="w-full md:w-auto md:min-w-[15rem]"
						backDateSelection={BookingStatus.value === "archived"}
						minDate={BookingStatus.value === "upcoming" ? moment().startOf("date").valueOf() : undefined}
						maxDate={BookingStatus.value === "archived" ? moment().subtract(1, "days").startOf("date").valueOf() : undefined}
						setRange={(dates) => setQuery({ ...Query, dates, page: 1 })}
						range={Query.dates}
						inputClass="!p-1.5 !text-xs w-full !justify-between"
					/>
				</div>
			</div>
			<CardsWrapper loading={Loading} className="pb-24 md:pb-28">
				<CardsRenderer
					items={Bookings.bookings}
					render={(booking, i) => {
						return <Booking key={i} booking={booking} type="flight" onReload={() => fetchBookings(BookingStatus.value, Query)} />;
					}}
				/>
			</CardsWrapper>
		</>
	);
}

export default FlightBookings;
